<template>
  <!-- <icon :name="iconClass"  class="myIcon"></icon>-->
  <svg :class="svgClass" >
    <use :xlink:href="iconName"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  // props: {
  //   // 图标文件名
  //   iconClass: {
  //     type: String,
  //     required: true
  //   }
  // },
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName () {
      return `#icon-${this.iconClass}`
    },
    svgClass () {
      if (this.className) {
        return 'myIcon ' + this.className
      } else {
        return 'myIcon'
      }
    }
  }
}
</script>

<style scoped>
  .myIcon {
    width: 1.4em;
    height: 1.4em;
    margin-right: 0.7em;
    fill: currentColor;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue